<div class="gs root-layout" [ngClass]="{'sidebar-opened': sidebarOpened}">
  <div class="custom-lay left-layout" [ngClass]="{'collapsed-sidebar': panelToggle}">
    <eyrus-side-panel>
      <eyrus-side-menu></eyrus-side-menu>
    </eyrus-side-panel>
  </div>
  <div class="lay right-layout gs flex-direction-column keep-lay">
    
    <app-header>
      <mat-progress-bar class="custom-progress-bar"
        color="accent"
        *ngIf="loading"
        mode="indeterminate">
      </mat-progress-bar>
    </app-header>


    <div class="app-wrapper">
      <div class="app-wrapper-content">
        <div class="app-wrapper-content-scroll">
          <router-outlet></router-outlet>
        </div>
        <div id="loading-ng-app" class="app-loading-container">
        <div class="lds-grid">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>

  </div>
</div>
